import { render } from "./TwoPanelCallouts.vue?vue&type=template&id=3fed4588"
import script from "./TwoPanelCallouts.vue?vue&type=script&lang=js"
export * from "./TwoPanelCallouts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__